// this is stored in the embeds server config (https://fryingpan.wixpress.com/services/com.wixpress.wix-anywhere-embed/edit)
// This is aimed to ease creating the values for fryingpan, copy the JSON and run copy(JSON.stringify(templatesMap)) in dev tools to get the paste ready value
export const templatesMap = {
  sch: {
    siteId: '7c84cd6f-3731-4d09-9771-06635ce05e25',
    metaSiteId: 'fadf247c-fa71-43e4-abdb-3c8edd495b3f',
    siteUrl: 'https://einatz.editorx.io/my-site-67/book-online'
  },
  schx: {
    siteId: '7c84cd6f-3731-4d09-9771-06635ce05e25',
    metaSiteId: 'fadf247c-fa71-43e4-abdb-3c8edd495b3f',
    siteUrl: 'https://einatz.editorx.io/my-site-67/book-online'
  },
  schr: {
    siteId: '003f293f-f988-420c-a250-5936bc04621a',
    metaSiteId: '14204753-a9bb-4509-b913-d3eaade54e91',
    siteUrl: 'https://einatz.wixsite.com/my-site-60/book-online'
  }
};
//# sourceMappingURL=template-mappings.js.map